import React, {useState ,useRef, useEffect } from "react";

import '../App.css';
import {useInView} from "react-intersection-observer";
import Grid from '@material-ui/core/Grid';
import Box from '@mui/material/Box';
import MenuSection from "./MenuSection";
import MenuItem from "./MenuItem";

function Menu({ city, ...props }) {
  let sections = props.sections;
  const sectionsSafe = Array.isArray(sections) ? sections : [];
  const [activeSectionIndexes, setActiveSectionIndexes] = useState([]);

  useEffect(() => {
    console.log(sections);
  },[sections]);

  function handleSetActiveSectionIndex(index, active) {
    setActiveSectionIndexes(prevIndexes => {
      if (active) {
        return [...prevIndexes, index];
      } else {
        return prevIndexes.filter(i => i !== index);
      }
    });
  }

  return (
    <>
      <Grid sx={0} md={2} className="font-link">
        <Box
          sx={{ display: { xs: "none", md: "block" } }}
          style={{ position: "sticky", top: "100px" }}
        >
          <ul style={{ listStyle: "none", fontSize: ".875rem" }}>
            {sectionsSafe.map((section, index) => {
              const sectionId = section?.id ?? `section-${index}`;
              return (
              <li key={sectionId}>
                {activeSectionIndexes.includes(index) ? (
                  <a
                    className="menuLink"
                    src={`#ref_${sectionId}`}
                    style={{ borderBottom: "1px solid #009de0", color: "#009de0" }}
                  >
                    {section?.title || `Sektion ${index+1}`}
                  </a>
                ) : (
                  <a className="menuLink" href={`#${sectionId}`}>
                    {section?.title || `Sektion ${index+1}`}
                  </a>
                )}
              </li>
            );})}
          </ul>
        </Box>
      </Grid>


      <Grid sx={12} md={6}>
        {sectionsSafe.map((section, index) => {
          const sectionId = section?.id ?? `section-${index}`;
          const sectionTitle = section?.title || `Sektion ${index+1}`;
          const items = Array.isArray(section?.items) ? section.items : [];
          return (
          <Box key={sectionId} id={`${sectionId}`}>
            <MenuSection
              title={sectionTitle}
              index={index}
              onSetActive={handleSetActiveSectionIndex}
            >
              {items.map((item, idx) => (
                <MenuItem city={city} sectionTitle={sectionTitle}
                  key={`${sectionId}-item-${item?.id ?? idx}`}
                  itemId={item.id}
                  sectionId={sectionId}
                  title={item.title}
                  description={item.description}
                  price={item.price}
                  optionKinds={item.optionsKinds || []}
                  extrasKinds={item.extrasKinds || []}
                  img={item.img}
                  onClickFood={props.handleClickFood}
                />
              ))}
            </MenuSection>
          </Box>
        );})}
      </Grid>

    </>
  );
}

export default Menu;